// extracted by mini-css-extract-plugin
module.exports = {"root":"quoted-tweet-container_root__92393","article":"quoted-tweet-container_article__FoJQN"};